<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div class="heading bold">
        <div class="page-title">
          <span>LUCID</span>
        </div>
        <div>
          <span>BIMILEAP USER AGREEMENT</span>
        </div>
        <div>
          <span>FOR LUCID MARKETPLACE SERVICES</span>
        </div>
      </div>
      <div class="text">
        <div>
          <div class="paragraph">
            <span>{{paragraphOne}}</span>
          </div>
          <div class="paragraph">
            <span>{{paragraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span>{{paragraphThree}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">1.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Our Services</span>
          </div>
          <div class="paragraph">
            <span class="title-number">1.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Description of Services.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionOneParagraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">2.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Payment and Performance</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Payment.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">2.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Taxes.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTwoParagraphThree}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">3.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Customer's Obligations</span>
          </div>
          <div class="paragraph">
            <span class="title-number">3.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Customer shall: </span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionThreeParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">3.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Prohibited Acts.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionThreeParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">3.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Customer's Acts or Omissions.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionThreeParagraphThree}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">3.4</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Feedback.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionThreeParagraphFour}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">4.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Ownership</span>
          </div>
          <div class="paragraph">
            <span class="title-number">4.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Work Product. </span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionFourParagraphOne}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">5.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Warranties</span>
          </div>
          <div class="paragraph">
            <span class="title-number">5.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Lucid's Warranty.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionFiveParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">5.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Disclaimer of Warranties. </span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionFiveParagraphTwo}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">6.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Indemnification; Limitation of Liability</span>
          </div>
          <div class="paragraph">
            <span class="title-number">6.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Indemnity.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionSixParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">6.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionSixParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">6.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionSixParagraphThree}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">6.4</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Limitations on Liability. </span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionSixParagraphFour}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">7.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Confidential Information</span>
          </div>
          <div class="paragraph">
            <span class="title-number">7.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Nondisclosure Obligation.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionSevenParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">7.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Exceptions.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionSevenParagraphTwo}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">8.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Respondent and Personal Data</span>
          </div>
          <div class="paragraph">
            <span class="title-number">8.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Role of Parties.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionEightParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">8.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Customer’s Control of Personal Data.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionEightParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">8.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Use and Processing of Personal Data.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionEightParagraphThree}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">9.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Termination</span>
          </div>
          <div class="paragraph">
            <span class="title-number">9.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Term.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionNineParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">9.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Termination and Suspension.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionNineParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">9.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Termination or Suspension to Protect Data.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionNineParagraphThree}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">9.4</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Survival.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionNineParagraphFour}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">10.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Additional Provisions</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Assignment.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Waiver.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Force Majeure.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphThree}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.4</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Relationship of the Parties.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphFour}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.5</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Governing Law.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphFive}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.6</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Submission to Jurisdiction.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphSix}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.7</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Notices.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphSeven}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.8</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Severability.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphEight}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">10.9</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title">Subject Headings.</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionTenParagraphNine}}</span>
          </div>
        </div>
        <div>
          <div class="section">
            <span class="title-number">11.</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="title bold">Definitions</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.1</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Bimileap App”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphOne}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.2</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Buyer Opportunity Data”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphTwo}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.3</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Confidential Information”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphThree}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.4</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Data Protection Laws and Regulations”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphFour}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.5</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Intellectual Property Rights”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphFive}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.6</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Laws”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphSix}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.7</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Lucid Marketplace”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphSeven}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.8</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Personal Data”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphEight}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.9</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Respondent Screening Data” </span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphNine}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.10</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Sample”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphTen}}</span>
          </div>
          <div class="paragraph">
            <span class="title-number">11.11</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="bold">“Respondents”</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>{{sectionElevenParagraphEleven}}</span>
          </div>
        </div>





      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "TermsOfService",

      computed:{
        paragraphOne(){
          return `THIS BIMILEAP USER AGREEMENT FOR LUCID MARKETPLACE SERVICES TERMS (“AGREEMENT”)
          GOVERNS LUCID’S PERFORMANCE OF MARKETPLACE SERVICES ON THE BIMILEAP APP. IN ORDER TO USE
          THE SERVICES YOU MUST BE AUTHORIZED TO ACT ON BEHALF OF YOUR ORGANIZATION. This Agreement
          is between the customer named in the Bimileap App (“You” or “Your” or “Customer”)
          and Lucid (each, a “Party,” collectively, the “Parties”) and constitutes the entire
          understanding related to the subject matter. By using the Services or otherwise
          accepting these terms when You create an account on the Bimileap App,
          You agree to be bound by this Agreement.`
        },
        paragraphTwo(){
          return `“Lucid” means (i) Lucid Holdings, LLC, a Delaware LLC with its principal place of
           business at 365 Canal St. Ste. 3100, New Orleans, LA 70130 U.S.A. with respect to
           Marketplace Services inside and outside of the United States and all other countries,
           exclusive of offerings in the following subsections (ii) or (iii); or (ii) with
           respect to all Marketplace Services that are shipped to, deployed or rendered
           within the European Union or South America, Lucid Holdings UK LTD, a company
           incorporated under the laws of the United Kingdom; or (iii) with respect to
           all Lucid Services that are shipped to, deployed or rendered within India,
           the Middle East, Asia, or Pacific countries, Lucid Holdings India Pvt Ltd,
           a company incorporated under the laws of India.`
        },
        paragraphThree(){
          return `You agree to pay all charges that may be incurred by you or on your behalf
          through the Site, at the price(s) in effect when such charges are incurred including,
          without limitation, all shipping and handling charges. In addition, you remain
          responsible for any taxes that may be applicable to your Transactions.`
        },
        sectionOneParagraphOne(){
          return `  Lucid will direct potential survey Respondents to
          surveys programmed and hosted on the Bimileap App (“Services” or “Marketplace Services”).`
        },
        sectionTwoParagraphOne(){
          return `If you wish to purchase any product or service made available through the Bimileap
          App including items sold by Lucid and items sold by Bimileap
          (each such purchase, a "Transaction"), you may be asked to supply certain information
          relevant to your Transaction including, without limitation, information about your method
          of payment (such as your payment card number and expiration date), your billing address,
          and your shipping information. YOU REPRESENT AND WARRANT THAT YOU HAVE THE LEGAL RIGHT TO
          USE ANY PAYMENT CARD(S) OR OTHER PAYMENT METHOD(S) UTILIZED IN CONNECTION WITH ANY
          TRANSACTION. By submitting such information, you grant to Lucid the right to provide
          such information to third parties for purposes of facilitating the completion of
          Transactions initiated by you or on your behalf. Verification of information may be
          required prior to the acknowledgment or completion of any Transaction.`
        },
        sectionTwoParagraphTwo(){
          return `Customer will pay Lucid for the Services in accordance with the pricing and other
          specifications stated in the Bimileap App. Payments on the Bimileap App may only be made
          using a credit card through the in-app payment process. All Transactions must be
          authorized for payment prior to the beginning of any Services.`
        },
        sectionTwoParagraphThree(){
          return `Customer shall be responsible for all sales, use and excise taxes, and any other similar taxes, duties and charges of any kind imposed by any federal, state or local governmental entity on any amounts payable by Customer hereunder. All federal, state or local taxes applicable to the Services shall be added to each Transaction for the Services. Customer shall pay all such taxes to Lucid unless a valid exemption certificate is furnished for each of the states of use of the Services by Customer.`
        },
        sectionThreeParagraphOne(){
          return `(a) reasonably cooperate with Lucid in all matters relating to the Services and
          provide such assistance as may reasonably be requested by Lucid, for the purposes of
          performing the Services;
          (b) respond promptly to Lucid’s requests to provide direction, information, approvals,
          authorizations or decisions that are reasonably necessary for Lucid to perform Services
          in accordance with this Agreement;
          (c) provide and obtain Customer materials and information as Lucid may reasonably
          request or Customer considers reasonably necessary to carry out the Services in a
          timely manner and ensure that such materials and information are complete and
          accurate in all material respects; and
          (d) comply with all applicable laws, regulations and governmental orders.`
        },
        sectionThreeParagraphTwo(){
          return `Customer shall not use the Services in any manner that is harmful, fraudulent,
          illegal, obscene or hateful, including directing Respondents to perform surveys
          that are harmful, fraudulent, illegal, obscene or hateful.`
        },
        sectionThreeParagraphThree(){
          return `If Lucid's performance of its obligations under this Agreement is prevented or
          delayed by any act or omission of Customer or its customers, Lucid shall not be deemed
          in breach of its obligations under this Agreement or otherwise liable for any costs,
          charges or losses sustained or incurred by Customer, in each case, to the extent
          arising directly or indirectly from such acts or omissions.`
        },
        sectionThreeParagraphFour(){
          return `If Customer gives Lucid any feedback, suggestions, recommendations, or other
          input regarding the Services or any Lucid product or technology ("Feedback"), then
          Customer hereby grants to Lucid, a worldwide, royalty-free, fully paid-up, non-exclusive,
          transferable, perpetual, irrevocable license (with rights to sublicense) to: (a) adapt,
          modify, and create derivative works of the Feedback, and (b) make, have made, use, copy,
          offer to sell, sell, perform, display, distribute, import, and otherwise dispose of the
          Feedback (and adaptations, modifications, and derivative works of the Feedback) and any
          product, technology, or service that incorporates, is combined or used with, or marketed
          for use or combination with, any Feedback.`
        },
        sectionFourParagraphOne(){
          return `All Intellectual Property Rights in and to Buyer Opportunity Data is owned
          exclusively by You. You, not Lucid, shall have sole responsibility for the accuracy,
          quality, integrity, legality, reliability, and appropriateness of any data submitted
          to or entered by You and Your Users on the Bimileap App. All Intellectual Property
          Rights in and to the Respondent Screening Data, Lucid Marketplace, and Lucid technology
          belong exclusively to Lucid Holdings, LLC and its licensors. You are granted no
          licenses of any kind to any Intellectual Property Rights of Lucid.`
        },
        sectionFiveParagraphOne(){
          return `Lucid warrants to Customer that it shall perform the Services in a professional
          and workmanlike manner in accordance with generally recognized industry
          standards for similar services.`
        },
        sectionFiveParagraphTwo(){
          return `EXCEPT FOR THE WARRANTY SET FORTH IN SECTION 5.1 ABOVE, LUCID MAKES NO WARRANTY
          WHATSOEVER WITH RESPECT TO THE SERVICES OR THIS AGREEMENT, INCLUDING ANY WARRANTY OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT, WHETHER EXPRESS
          OR IMPLIED BY LAW, COURSE OF DEALING, COURSE OF PERFORMANCE, USAGE OF TRADE OR OTHERWISE
          AND ALL SUCH WARRANTIES ARE HEREBY EXPRESSLY DISCLAIMED.`
        },
        sectionSixParagraphOne(){
          return `Customer shall defend, indemnify and hold Lucid, its licensors, and parent
          company, subsidiaries, affiliates, officers, directors, employees, attorneys and
          agents harmless from and against any and all allegations, claims, costs, damages,
          losses, liabilities and expenses (including reasonable attorneys’ fees and costs)
          arising out of or in connection with Customer’s acts or omissions related to this
          Agreement including, but not limited, to violations of a third party’s proprietary
          rights, failure to comply with any applicable law, breach of this Agreement, and
          any obligation related to Personal Data.`
        },
        sectionSixParagraphTwo(){
          return `EXCEPT FOR A VIOLATION OF LUCID’S INTELLECTUAL PROPERTY RIGHTS, OR BREACH OF
          CUSTOMER’S CONFIDENTIALITY OBLIGATIONS HEREUNDER, IN NO EVENT SHALL EITHER PARTY BE
          LIABLE TO THE OTHER PARTY OR TO ANY OTHER THIRD PARTY FOR ANY LOSS OF USE, LOST REVENUE
          OR PROFIT, OR FOR ANY CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL OR PUNITIVE
          DAMAGES WHETHER ARISING OUT OF BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE) OR
          OTHERWISE, REGARDLESS OF WHETHER SUCH DAMAGES WERE FORESEEABLE AND WHETHER OR NOT THE
          CUSTOMER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, AND NOTWITHSTANDING THE
          FAILURE OF ANY AGREED OR OTHER REMEDY OF ITS ESSENTIAL PURPOSE.`
        },
        sectionSixParagraphThree(){
          return `IN NO EVENT SHALL LUCID'S AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS
          AGREEMENT, WHETHER ARISING OUT OF OR RELATED TO BREACH OF CONTRACT, TORT
          (INCLUDING NEGLIGENCE) OR OTHERWISE, EXCEED THE AGGREGATE AMOUNTS PAID TO LUCID BY
          CUSTOMER ON THE BIMILEAP APP IN THE 12 MONTH PERIOD PRECEDING THE EVENT GIVING RISE
          TO THE CLAIM.`
        },
        sectionSixParagraphFour(){
          return `The limitation of liability set forth in Section 5, 6.2, and 6.3 above shall not
          apply to (1) liability from a Party’s gross negligence or willful misconduct that result
          in death, disability, or the destruction of tangible personal property, and not
          proximately caused by the other Party, or (2) Customer’s obligation to indemnify
          Lucid hereunder, including any liability arising under Section 6.1 or (3) Customer’s
          violation of Lucid’s Intellectual Property Rights or (4) a breach of Customer’s
          confidentiality obligations.`
        },
        sectionSevenParagraphOne(){
          return `During the term of this Agreement, the Parties may disclose certain Confidential
          Information to each other solely to permit the Parties to perform its obligations under
          this Agreement. Each Party shall refrain from using or exploiting any and all
          Confidential Information of the other Party for any purposes or activities other than
          those specifically authorized in this Agreement, and each Party shall not disclose any
          Confidential Information of the other Party to any person, firm or corporation, except
          to its employees, agents, or contractors with a need to know in connection with the
          Services and who have executed a nondisclosure agreement at least as protective of
          confidential information as the terms of this Agreement. Both Parties shall implement
          effective security procedures in order to avoid disclosure or misappropriation of the
          other Party’s Confidential Information.`
        },
        sectionSevenParagraphTwo(){
          return `The provisions of this Section 7 shall not apply, or cease to apply, to data and
          information disclosed by a Party to the other Party that (a) was already rightfully known
          by the Party prior to disclosure, (b) is or becomes public through no fault of the Party,
          (c) was rightfully given to the Party by an unaffiliated third party without restriction
          on disclosure, (d) was independently developed by the Party without reference to the
          Confidential Information, or, (e) is required to be disclosed pursuant to any statutory
          or regulatory provision, relevant governing body or government, or court order, provided,
          however, that a Party shall give prior written notice to the other Party of such legal
          disclosure requirement so that the Party can take appropriate action to protect the
          confidentiality, and prevent the unauthorized use or appropriation of such Confidential
          Information.`
        },
        sectionEightParagraphOne(){
          return `Customer acknowledges and agrees that with regard to the control and processing
          of personal data, Customer is the Controller and Lucid is the Processor.`
        },
        sectionEightParagraphTwo(){
          return `Customer shall control and use personal data in accordance with the requirements
          of Data Protection Laws and Regulations. Customer’s instructions for the processing of
          Personal Data shall comply with Data Protection Laws and Regulations. Customer shall have
          sole responsibility for the accuracy, quality, appropriateness and legality of any
          personal data and the means by which the Customer acquires such personal data for use in
          connection with the Services.`
        },
        sectionEightParagraphThree(){
          return `The Parties shall only use and process personal data under this Agreement in
          accordance with the data processing terms and conditions set forth in the Order
          Confirmation. Customer hereby authorizes and agrees to Lucid’s use of sub-processors
          to fulfill its obligations under this Agreement. Lucid publishes a list of its
          sub-processors of Personal Data at https://luc.id/sub-processors/, which may be amended
          from time to time by Lucid. By following the instructions at this site, Customer may
          subscribe to receive notification of changes to the sub-processors used by Lucid.`
        },
        sectionNineParagraphOne(){
          return `This Agreement is effective for a 1 year period (“Term”) starting on the
          Effective Date. The Term automatically renews for successive 1 year periods with each new
          Transactions unless a Party provides notice of termination before the expiration of the
          Term; any renewal shall be subject to Lucid’s then current terms and conditions for
          Marketplace Services.`
        },
        sectionNineParagraphTwo(){
          return `Lucid may unilaterally suspend or terminate this Agreement by giving notice to
          Customer if Customer:
          (a) fails to pay any amount when due under this Agreement and such failure
          continues for 15 days after Customer receives written notice of nonpayment;
          (b) materially breaches any other provisions of this Agreement and fails to fully cure
          within thirty (30) days after receiving written notice of the breach; or
          (c) becomes insolvent, files a petition for bankruptcy or commences or has commenced
          against it proceedings relating to bankruptcy, receivership, reorganization or
          assignment for the benefit of creditors.`
        },
        sectionNineParagraphThree(){
          return `In order to protect personal data and Confidential Information, Lucid may,
          without liability, suspend or terminate this Agreement: (i) following a possible or
          actual security breach or cyber-attack on Lucid, (ii) to protect Lucid’s network in the
          Public Cloud, (iii) as required by a governmental entity or law enforcement agency.`
        },
        sectionNineParagraphFour(){
          return `Provisions of this Agreement, which by their nature should apply beyond the Term,
          will remain in force after termination or expiration of this Agreement, including without
          limitation Sections 6, 7, 9, and 10. In addition, the terms of this Agreement will
          survive and apply to any Order Confirmations outstanding as of the effective date of
          termination or expiration. Any termination of this Agreement by Lucid shall automatically
          terminate all outstanding Order Confirmations and purchase orders unless Lucid
          specifically agrees otherwise.`
        },
        sectionTenParagraphOne(){
          return `Customer may not assign this Agreement, by contract or operation of law,
          including in connection with a merger, acquisition, or other change of control, without
          Lucid’s prior written consent. Any attempted assignment without Lucid’s prior written
          consent will be null and void.`
        },
        sectionTenParagraphTwo(){
          return `No waiver by either Party of any of the provisions of this Agreement is effective
          unless explicitly set forth in writing and signed by the waiving Party. No single or
          partial exercise of any right, remedy, power or privilege hereunder precludes any other
          or further exercise thereof or the exercise of any other right, remedy, power or
          privilege.`
        },
        sectionTenParagraphThree(){
          return `Lucid shall not be liable or responsible to Customer, nor be deemed to have
          defaulted or breached this Agreement, for any failure or delay in fulfilling or
          performing any term of this Agreement when and to the extent such failure or delay is
          caused by or results from acts or circumstances beyond the reasonable control of Lucid
          including, without limitation, acts of God, flood, fire, earthquake, hurricane,
          explosion, governmental actions, war, invasion or hostilities (whether war is declared
          or not), terrorist threats or acts, riot, or other civil unrest, national emergency,
          revolution, insurrection, epidemic, lock-outs, strikes or other labor disputes
          (whether or not relating to either Party's workforce), or restraints or delays affecting
          carriers or inability or delay in obtaining supplies of adequate or suitable materials,
          materials or telecommunication breakdown or power outage.`
        },
        sectionTenParagraphFour(){
          return `The relationship between the Parties is that of independent contractors. Nothing
          contained in this Agreement shall be construed as creating any agency, partnership, joint
          venture or other form of joint enterprise, employment or fiduciary relationship between
          the Parties, and neither Party shall have authority to contract for or bind the other
          Party in any manner whatsoever.`
        },
        sectionTenParagraphFive(){
          return `All matters arising out of or relating to this Agreement are governed by and
          construed in accordance with the internal laws of the State of New York (without
          reference to its principles of conflicts of law).`
        },
        sectionTenParagraphSix(){
          return `Any legal suit, action or proceeding arising out of or relating to this
          Agreement shall be instituted in the federal courts of the United States of America or
          the courts of the New York in each case located in New York, and each Party irrevocably
          submits to the exclusive jurisdiction of such courts in any such suit, action or
          proceeding.`
        },
        sectionTenParagraphSeven(){
          return `All notices, requests, consents, claims, demands, waivers and other
          communications hereunder (each, a "Notice") shall be in writing and addressed to the
          Parties at the addresses set forth in the Order Confirmation or to such other address
          that may be designated by the receiving Party in writing. All Notices shall be delivered
          by personal delivery, nationally recognized overnight courier (with all fees pre-paid),
          certified or registered mail (in each case, return receipt requested, postage prepaid),
          or if to Lucid, notice can also be delivered to legal@luc.id. Except as otherwise
          provided in this Agreement, a Notice is effective only upon receipt by the receiving
          Party.`
        },
        sectionTenParagraphEight(){
          return `If any term or provision of this Agreement is invalid, illegal or unenforceable
          in any jurisdiction, such invalidity, illegality or unenforceability shall not affect any
          other term or provision of this Agreement or invalidate or render unenforceable such term
          or provision in any other jurisdiction.`
        },
        sectionTenParagraphNine(){
          return `The subject headings of this Agreement are included for purposes of convenience
          only and shall not affect the construction or interpretation of any of its provisions.`
        },
        sectionElevenParagraphOne(){
          return `means the application and technology of BimiCorp LLC used to facilitate
          Transactions between Lucid and Customer.`
        },
        sectionElevenParagraphTwo(){
          return `means any data entered or provided by Respondents once they exit or are otherwise
          redirected from the Lucid Marketplace to a third-party service to conclude the Buyer
          Opportunity, which is never stored on the Lucid Marketplace or in the Public Cloud.`
        },
        sectionElevenParagraphThree(){
          return `means information disclosed by a party (“Discloser”) to the other party
          (“Recipient”) in connection with the use or provision of the Services that is either
          marked as confidential or would reasonably be considered as confidential under the
          circumstances. Lucid’s Confidential Information includes the terms of this Agreement
          and any security information about the Services.`
        },
        sectionElevenParagraphFour(){
          return `means all laws and regulations, including laws and regulations of the
          United States, European Union, the European Economic Area and their member states,
          Switzerland and the United Kingdom, applicable to the Processing of Personal Data
          under the Agreement.`
        },
        sectionElevenParagraphFive(){
          return `means all rights in patents, copyrights, patents, trade secrets, trademarks
          and other proprietary rights recognized anywhere in the world.`
        },
        sectionElevenParagraphSix(){
          return `means all applicable laws, rules, statutes, decrees, decisions, orders,
          regulations, judgments, codes, ordinances, and requirements of any government
          authority (federal, state, local, or international) having jurisdiction.`
        },
        sectionElevenParagraphSeven(){
          return `means the Public Cloud platform and application of Lucid Holdings, LLC based on
          Lucid Technology that is used to facilitate Completed transactions between Buyers and
          Suppliers related to Buyer Opportunities.`
        },
        sectionElevenParagraphEight(){
          return `has the meaning specified in the Order Confirmation.`
        },
        sectionElevenParagraphNine(){
          return `means all data supplied, indexed, or otherwise transmitted by suppliers or
          provided by Respondents for the purpose of asking and answering questions and qualifying
          each Respondent in an attempt to complete a survey.`
        },
        sectionElevenParagraphTen(){
          return `means Respondents made available to Customer as part of the Services.`
        },
        sectionElevenParagraphEleven(){
          return `means individuals who have accepted to be part of the Services, by answering
          questions to surveys.`
        },


      }
    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .text{
    padding: 5%;
    font-size: 14px;
    line-height: 17px;
  }

  .paragraph{
    padding: 1% 0;
  }

  .section{
    padding: 5% 0;
    font-weight: bold;
  }

  .title-number{
    /*padding-right: 5%;*/
  }

  .title{
    text-decoration: underline;
  }

  .bold{
    font-weight: bold;
  }

  .heading{
    text-align: center;
    padding: 1em 0;

    .page-title{
      padding: 3em 0 1em 0;
      font-size: 22pt;
    }
  }

</style>
